const pill = {
    backgroundColor: 'primary.main',
    '& .MuiChip-label': {
        fontFamily: ['Avenir-Black', 'Arial'].join(','),
        fontSize: '0.875rem',
        fontWeight: '800',
        margin: '4px',
        color: 'secondary.dark',
    },
};
export default {
    pill,
};
